import {
  CheckDetails,
  CheckDetailsMetadata,
  CheckMetadataType,
  PayAndGoMetadata,
} from '@ancon/wildcat-types'

function isExtractedPayAndGoCheck(check: CheckDetails) {
  const meta: CheckDetailsMetadata<PayAndGoMetadata> | undefined =
    check.metadata.find(m => m.type === CheckMetadataType.PayAndGo)

  return meta?.metadata?.isOriginalCheck === false
}

export default isExtractedPayAndGoCheck
